import { defineComponent as b, computed as u, useSlots as $, unref as a, openBlock as l, createElementBlock as f, createVNode as m, mergeProps as s, withCtx as n, renderSlot as r, createElementVNode as j, normalizeClass as N, normalizeStyle as y, createBlock as h, createCommentVNode as w } from "vue";
import d from "./ghl-ui.es247.js";
import "./ghl-ui.es248.js";
import c from "./ghl-ui.es249.js";
const x = {
  key: 0,
  class: "ghl-avatar-container"
}, C = b({
  name: "UIAvatar",
  inheritAttrs: !1
}), F = b({
  ...C,
  props: {
    size: {
      type: [Number, String],
      default: "medium"
    },
    objectFit: {
      type: String,
      default: "fill"
    },
    round: {
      type: Boolean,
      default: !0
    },
    src: {
      type: String,
      default: void 0
    },
    fallbackSrc: {
      type: String
    },
    style: {
      type: Object
    },
    indicator: {
      type: String,
      required: !1
    },
    indicatorSize: {
      type: Number,
      default: void 0
    }
  },
  setup(e) {
    const i = e, z = u(() => {
      const t = {
        small: 12,
        medium: 14,
        large: 16
      };
      return i.indicatorSize ? i.indicatorSize : t[i.size] ? t[i.size] : 12;
    }), g = (t) => typeof t == "number" ? { width: `${t + 4}px`, height: `${t + 4}px` } : {
      small: { width: "34px", height: "34px" },
      medium: { width: "40px", height: "40px" },
      large: { width: "46px", height: "46px" }
    }[t] || { width: `${t + 4}px`, height: `${t + 4}px` }, k = u(() => g(i.size)), v = $(), o = (t) => !isNaN(t) && !isNaN(parseFloat(t));
    return (t, S) => a(v).overlay ? (l(), f("div", x, [
      m(a(c), s(t.$attrs, {
        class: "ghl-avatar",
        style: e.style,
        src: a(d)(e.src) ? "undefined" : e.src,
        "fallback-src": e.fallbackSrc,
        round: e.round,
        "object-fit": e.objectFit,
        size: e.size
      }), {
        default: n(() => [
          r(t.$slots, "default")
        ]),
        _: 3
      }, 16, ["style", "src", "fallback-src", "round", "object-fit", "size"]),
      j("div", {
        class: N(["ghl-avatar-backdrop", [
          `ghl-avatar-backdrop-${e.size}`,
          e.round ? "ghl-avatar-round-backdrop" : null
        ]]),
        style: y({
          width: o(e.size) ? e.size + "px" : null,
          height: o(e.size) ? e.size + "px" : null
        })
      }, [
        r(t.$slots, "overlay")
      ], 6)
    ])) : e.indicator ? (l(), f("div", {
      key: 1,
      class: "n-avatar-with-indicator",
      style: y(k.value)
    }, [
      m(a(c), s(t.$attrs, {
        class: "ghl-avatar",
        style: e.style,
        src: a(d)(e.src) ? "undefined" : e.src,
        "fallback-src": e.fallbackSrc,
        round: e.round,
        "object-fit": e.objectFit,
        size: e.size
      }), {
        default: n(() => [
          r(t.$slots, "default")
        ]),
        _: 3
      }, 16, ["style", "src", "fallback-src", "round", "object-fit", "size"]),
      e.indicator ? (l(), h(a(c), {
        key: 0,
        size: z.value,
        src: e.indicator,
        round: e.round,
        class: "indicator"
      }, null, 8, ["size", "src", "round"])) : w("", !0)
    ], 4)) : (l(), h(a(c), s({ key: 2 }, t.$attrs, {
      class: "default-avatar",
      style: e.style,
      src: a(d)(e.src) ? "undefined" : e.src,
      "fallback-src": e.fallbackSrc,
      round: e.round,
      "object-fit": e.objectFit,
      size: e.size
    }), {
      default: n(() => [
        r(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["style", "src", "fallback-src", "round", "object-fit", "size"]));
  }
}), M = F;
export {
  M as default
};
